import React from 'react';

type IconMenuProps = {
    className?: string;
};

export function IconMenu(props: IconMenuProps) {
    const { className = '' } = props;

    return (
        <svg className={`${className}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
            <path d="M144-264v-72h672v72H144Zm0-180v-72h672v72H144Zm0-180v-72h672v72H144Z" />
        </svg>
    );
}

export default IconMenu;
